import React = require("react");
import BarChartGroup = MarketingData.BarChartGroup;
import {HorizontalGroupBarChart} from "../charts/HorizontalGroupBarChart";
import {MarketingData} from "../data/MarketingData";
import "./LocationsTrendWidget.scss";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {EmptyState, infoIcons} from "@vebox/etui-core";
import {Display} from "../../../components/Display";
import AutoSizer from "react-virtualized-auto-sizer";

declare var AppTranslations: AppTranslations;

interface LocationsTrendProps {
    title: string;
    bestLocationsData: BarChartGroup[];
    goToLocation: () => any;
    unitOfMeasure: string;
    wide: boolean;
}

export const LocationsTrendWidget: React.SFC<LocationsTrendProps> = (props: LocationsTrendProps) => {
    let widgetClassName = "marketing-widget";
    if (props.wide) {
        widgetClassName += " marketing-widget-2x3";
    } else {
        widgetClassName += " marketing-widget-2x2 marketing-widget-2x2--reduced";
    }
    return (
        <VeBoxCard className={widgetClassName + " no-margin"}>
            <VeBoxCard.Header title={props.title}/>
            <VeBoxCard.Body className="marketing-widget__content marketing-locations-widget">
                <Display isVisible={props.bestLocationsData.length === 0}>
                    <EmptyState>
                        <EmptyState.InfoIcon
                            styles={{
                                root: {
                                    color: "var(--empty-indicator-svg-stroke)",
                                }
                            }}
                            glyph={infoIcons.NoContent}
                        />
                        <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                        <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                    </EmptyState>
                </Display>
                <Display isVisible={props.bestLocationsData.length > 0}>
                    <div className="marketing-locations-widget__container">
                        <AutoSizer style={{width: "auto", height: "auto"}}>
                            {({width, height}) =>
                                <HorizontalGroupBarChart
                                    width={width}
                                    height={height}
                                    color={null}
                                    data={props.bestLocationsData}
                                    xUnitOfMeasure={props.unitOfMeasure}
                                    onYFieldsClick={props.goToLocation}
                                    labelsOptions={{externalLegend: true}}
                                />
                            }
                        </AutoSizer>
                    </div>
                </Display>
            </VeBoxCard.Body>
        </VeBoxCard>
    );
};
